import { getImageUrl } from '@/utils/helpers'
import { TeamMember } from '@/types'

interface TeamMemberCardProps {
  member: TeamMember
}

function TeamMemberCard({ member }: TeamMemberCardProps) {
  const defaultAvatar = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRTVFN0VCIi8+CjxwYXRoIGQ9Ik0xMDAgMTAwQzExNi41NjkgMTAwIDEzMCA4Ni41Njg1IDEzMCA3MEMxMzAgNTMuNDMxNSAxMTYuNTY5IDQwIDEwMCA0MEM4My40MzE1IDQwIDcwIDUzLjQzMTUgNzAgNzBDNzAgODYuNTY4NSA4My40MzE1IDEwMCAxMDAgMTAwWiIgZmlsbD0iIzlDQTNCNCIvPgo8cGF0aCBkPSJNMTAwIDExMEM3NC42MjQ0IDExMCA1NCAxMzAuNjI0IDU0IDE1NlYxNzBIMTQ2VjE1NkMxNDYgMTMwLjYyNCAxMjUuMzc2IDExMCAxMDAgMTEwWiIgZmlsbD0iIzlDQTNCNCIvPgo8L3N2Zz4='

  // Use photo.url if available (converted to API endpoint), otherwise use default avatar
  const photoUrl = member.photo?.url ? getImageUrl(member.photo.url) : defaultAvatar

  return (
    <div className={`team-member-card ${member.featured ? 'featured' : ''}`}>
      <div className="member-photo-container">
        <img
          src={photoUrl}
          alt={member.name}
          className="member-photo"
          onError={(e) => {
            // If image fails to load, use default avatar
            e.currentTarget.src = defaultAvatar
          }}
        />
        {member.featured && (
          <div className="featured-badge">
            <span>Équipe principale</span>
          </div>
        )}
      </div>

      <div className="member-info">
        <h3 className="member-name">{member.name}</h3>
        <p className="member-role">{member.role}</p>
        {member.bio && (
          <p className="member-bio">{member.bio}</p>
        )}
      </div>
    </div>
  )
}

export default TeamMemberCard
